import redTemplate from '../../../assets/project-red-template.jpeg';
import comfortTemplate from '../../../assets/comfort-project.jpeg';
import blueTemplate from '../../../assets/blue-template.png';
import blackTemplate from '../../../assets/black-template.png';
import flowlyImmage from '../../../assets/flowly-social.png'
import pizzeriaImmage from '../../../assets/pizzeria-site.png'
import TattoImage from '../../../assets/tattooo.jpeg'
import MoreVisionImage from '../../../assets/more-vision-image.png'
import corsaroEtnaPalace from '../../../assets/corsaro-etna-palace.png'
import CurrencyConverter from '../../../assets/currencyConverter.png'
import villaAranjaya from '../../../assets/villa-aranjaya.png'


const projects = [

    {
      id: 'villa_aranjaya',
      image: villaAranjaya,
      link:'https://wpdevvillaaranjaya.morevision.it/index.html',
      title: 'villa Aranjaya',
      description: 'A Villa web site',
    },
    {
      id: 'corsaroEtnaPalace',
      image: corsaroEtnaPalace,
      link:'https://corsaroetnapalace.it/',
      title: 'corsaroEtnaPalace',
      description: 'A b&b web site',
    },
    {
      id: 'moreVision',
      image: MoreVisionImage,
      link:'https://www.morevision.it/',
      title: 'MoreVision',
      description: 'A web agency web site',
    },
    {
      id: 'Tattoo',
      image: TattoImage,
      link: null,
      title: 'Tattoo',
      description: 'A Tattoo web site',
    },
    {
      id: 'Flowly',
      image: flowlyImmage,
      title: 'Flowly',
      description: 'A social web app',
    },
    {
      id:'currencyConverter',
      image: CurrencyConverter,
      link:'https://currency-converte-mario.netlify.app/',
      title: 'currency Converter',
      description: 'A currency Converter web app maked in angular',
    },
    {
      id: 'pizzeriaImmage',
      image: pizzeriaImmage,
      link:null,
      title: 'pizzeriaImmage',
      description: 'A pizzeriaImmage web app',
    },
    {
      id: 'red-template',
      image: redTemplate,
      link:null,
      title: 'Red Template',
      description: 'Red Template Description',
    },
    {
      id: 'comfort-template',
      image: comfortTemplate,
      link:null,
      title: 'Comfort Template',
      description: 'Comfort Template Description',
    },
    {
      id: 'blue-template',
      image: blueTemplate,
      link:null,
      title: 'Comfort Template',
      description: 'Comfort Template Description',
    },
    {
      id: 'black-template',
      image: blackTemplate,
      link:null,
      title: 'Comfort Template',
      description: 'Comfort Template Description',
    },

    
  ];


  export default projects;